import { useEffect } from "react";

/**
 * Registers /sw.js (PWA shell) on mount. Keeps the OneSignal SW untouched.
 * Shows a minimal "aggiornamento disponibile" toast when a new SW takes over.
 */
export default function ServiceWorkerRegister() {
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    if (process.env.NODE_ENV === "development") return; // avoid CRA HMR conflict

    const register = async () => {
      try {
        const reg = await navigator.serviceWorker.register("/sw.js", {
          scope: "/",
        });
        // Auto-activate new worker silently. No toast, no prompt.
        reg.addEventListener("updatefound", () => {
          const nw = reg.installing;
          if (!nw) return;
          nw.addEventListener("statechange", () => {
            if (nw.state === "installed" && navigator.serviceWorker.controller) {
              nw.postMessage("SKIP_WAITING");
            }
          });
        });
      } catch (err) {
        // SW registration is non-fatal
        // eslint-disable-next-line no-console
        console.warn("[SW] registration failed", err);
      }
    };

    // defer until window load so it doesn't compete with first paint
    if (document.readyState === "complete") register();
    else window.addEventListener("load", register, { once: true });
  }, []);

  return null;
}
